import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
function CellBrief(props) {
    const { className, briefClass, ...restProps } = props;
    return (React.createElement(View, { className: classNames(prefixClassname("cell__brief"), className, briefClass), ...restProps }));
}
export default CellBrief;
